import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import './mixins'
import './plugins/element.js'
import './modals-register.js'
import './assets/styles/index.styl'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import EllipsisText from './components/EllipsisText.vue'
import UiController from './directives/UiController'
Vue.config.productionTip = false
Vue.directive('uac', UiController)
Vue.directive('clickoutside', Clickoutside)
Vue.component('ellipsis-text', EllipsisText)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
